import { useQuery } from "@tanstack/react-query";
import ms from "ms";
import { AccountClient, type AccountProfileDrawerResponse } from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";
import { ACCOUNT_PROFILE_DRAWER_QUERY_KEY } from "@features/unified-user-header-feature/utils/HeaderQueryKeys";

export function useGetAccountProfileDrawerProfile(enabled: boolean) {
  const api = useApi(AccountClient);

  return useQuery<AccountProfileDrawerResponse, Error>({
    queryKey: [ACCOUNT_PROFILE_DRAWER_QUERY_KEY],
    queryFn: async () => await api.getAccountProfileDrawer(),
    enabled,
    staleTime: ms("5m"),
  });
}
